import type { Density } from "../density";

// Row and cell sizes by density (ADR 0016). Comfortable rows are 48 px; compact rows are 36 px.
export const rowClasses: Record<Density, string> = {
  comfortable: "h-12",
  compact: "h-9",
};

export const cellClasses: Record<Density, string> = {
  comfortable:
    "px-3 py-2 first:pl-5 last:pr-5 @max-[720px]/dt:first:pl-3 @max-[720px]/dt:last:pr-3",
  compact:
    "px-2.5 py-1 first:pl-4 last:pr-4 @max-[720px]/dt:first:pl-2.5 @max-[720px]/dt:last:pr-2.5",
};
